import React, {useRef, useEffect} from 'react';
import {
    Button,
    Input,
    Select,
    Divider,
    Checkbox,
    Flex,
    Form
} from 'antd';
import {
    LoadingOutlined,
    SearchOutlined,
    CloseOutlined,
} from '@ant-design/icons';
import {useStore} from "@/store/useStore";
import "./MtpFiltersBar.css";
import {MtpFilters} from "@/store/types/MtpFilters";
import {SettlementAutoComplete} from "@/components/Filters/SettlementAutoComplete";

type MtpFiltersBarPropsType = {
}
export const MtpFiltersBar: React.FC<MtpFiltersBarPropsType> = (props) => {
    const [form] = Form.useForm<MtpFilters>();
    const {loading, mtpFilters, regionOptions, hideSidebar, patchMtpFilters, clearMtpFilters} = useStore();
    const selectedRegionId = useRef(mtpFilters.regionId);
    const [selectedRegionIdValue, setSelectedRegionIdValue] = React.useState(mtpFilters.regionId);
    
    useEffect(() => {
        selectedRegionId.current = mtpFilters.regionId;
        setSelectedRegionIdValue(mtpFilters.regionId);
        form.setFieldsValue(mtpFilters);
    }, [mtpFilters]);
    
    const onFormValueChanged = (value: Record<string, any>) => {
        if (Object.prototype.hasOwnProperty.call(value, 'regionId')) {
            const regionId = value['regionId'];
            selectedRegionId.current = regionId;
            setSelectedRegionIdValue(regionId);
            form.setFieldValue('settlementId', undefined);
        }
    }
    
    const onSearch = (values: MtpFilters) => {
        patchMtpFilters(values);
        hideSidebar();
    }
    
    return (
        <div>
            <div style={{maxWidth: '454px', padding: '22px', borderRadius: '16px', backgroundColor: "#F5F5F5"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems:'center', marginBottom: '32px'}}>
                    <span style={{fontSize: '18px', fontWeight: 500}}>Фільтри МТП</span>
                    <span>
                        <Button 
                            icon={<CloseOutlined />} 
                            onClick={clearMtpFilters}
                            style={{backgroundColor: 'transparent', height: '42px'}}
                        >Скинути фільтри</Button>
                    </span>
                </div>
                <Form<MtpFilters>
                    form={form}
                    layout="vertical"
                    disabled={loading}
                    className="mtp-filters-form"
                    onFinish={onSearch}
                    onValuesChange={onFormValueChanged}
                >
                    <div>
                        <Form.Item label="Пошук по унікальному номеру" name="searchText">
                            <Input
                                disabled={loading}
                                allowClear
                                placeholder={'Введіть унікальний номер'}
                                suffix={
                                    loading ? <LoadingOutlined /> : <SearchOutlined />
                                }
                            />
                        </Form.Item>
    
                        <Form.Item label="Область" name="regionId">
                            <Select
                                showSearch
                                allowClear
                                options={regionOptions}
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                placeholder={'Виберіть область'}
                            />
                        </Form.Item>
    
                        <Form.Item label="Регіон" name="settlementId">
                            <SettlementAutoComplete regionId={selectedRegionIdValue}/>
                        </Form.Item>
                        <Form.Item name="includeUnavailablePlaces" valuePropName="checked">
                            <Checkbox>Показувати МТП, де немає вільних місць</Checkbox>
                        </Form.Item>
                    </div>
                    <div>
                        <div className="form-group-title">Тип поселення:</div>
                        <Form.Item name="freeAccommodation" valuePropName="checked">
                            <Checkbox>Безкоштовно</Checkbox>
                        </Form.Item>
                        <Form.Item name="paidAccommodation" valuePropName="checked">
                            <Checkbox>Платно</Checkbox>
                        </Form.Item>
                    </div>
                    <div>
                        <div className="form-group-title">Зручності:</div>
                        <Form.Item name="hasWc" valuePropName="checked">
                            <Checkbox>Наявність туалету </Checkbox>
                        </Form.Item>
                        <Form.Item name="showerOrBathtubAvailable" valuePropName="checked">
                            <Checkbox>Наявність душу / ванної </Checkbox>
                        </Form.Item>
    
                        <Form.Item name="kitchenAvailable" valuePropName="checked">
                            <Checkbox>Наявність кухні</Checkbox>
                        </Form.Item>
                        <Form.Item name="workingElevatorAvailable" valuePropName="checked">
                            <Checkbox>Навність працюючого ліфта</Checkbox>
                        </Form.Item>
                    </div>
                    <div>
                        <div className="form-group-title">Типи кімнат:</div>
                        <Form.Item name="familyRooms" valuePropName="checked">
                            <Checkbox>Для сімей</Checkbox>
                        </Form.Item>
                        <Form.Item name="maleRooms" valuePropName="checked">
                            <Checkbox>Для чоловіків</Checkbox>
                        </Form.Item>
                        <Form.Item name="femaleRooms" valuePropName="checked">
                            <Checkbox>Для жінок</Checkbox>
                        </Form.Item>
                        <Form.Item name="spaceAvailable" valuePropName="checked">
                            <Checkbox>Наявність окремих кімнат</Checkbox>
                        </Form.Item>
                        <Form.Item name="petsAvailable" valuePropName="checked">
                            <Checkbox> Наявність кімнат для проживання з тваринами</Checkbox>
                        </Form.Item>
                        <Form.Item name="disabledOrReducedMobilityAvailable" valuePropName="checked">
                            <Checkbox>Підходить для осіб з інвалідністю та маломобільних груп</Checkbox>
                        </Form.Item>
                        <Form.Item name="bunkBedsAvailable" valuePropName="checked">
                            <Checkbox>Наявність двоярусних ліжко-місць</Checkbox>
                        </Form.Item>
                    </div>
                    <Divider />
                    <Form.Item>
                        <Flex justify='center' align='center'>
                            <Button htmlType="submit" className='submit-button'>Знайти житло</Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
